import * as React from 'react'

import { palette } from 'main/ui'
import { SVGResponsive } from './common'

function Warning() {
  return (
    <SVGResponsive width={20} height={19}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36333 1.01046L0.256526 15.8513C-0.0835942 16.4972 -0.085625 17.2925 0.251192 17.9405C0.588008 18.5885 1.21308 18.9918 1.8932 19H18.1068C18.7869 18.9918 19.412 18.5885 19.7488 17.9405C20.0856 17.2925 20.0836 16.4972 19.7435 15.8513L11.6367 1.01046C11.2897 0.383118 10.6691 0 10 0C9.33089 0 8.71034 0.383118 8.36333 1.01046Z"
        fill={palette.goldenrod}
      />
      <path
        d="M10 7V11"
        stroke={palette.white}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse cx="10" cy="15" rx="0.909091" ry="1" fill={palette.white} />
    </SVGResponsive>
  )
}

export default React.memo(Warning)
